import { MONTH_NAMES } from '@/app/lib/dates/constants'
import { extractDateParts } from '@/app/lib/dates'
import type { DateParts } from '@/app/lib/dates'

export interface FaqDateRange {
  readonly inicio: string
  readonly fin: string
}

/** "2026-07-12" → "12 de julio de 2026". Sin `Date`: no hay desfase de zona. */
function formatLongDate({ day, month, year }: DateParts): string | null {
  const monthName = MONTH_NAMES[Number(month) - 1]
  if (!monthName) return null
  return `${Number(day)} de ${monthName} de ${year}`
}

/**
 * Rango de fechas de un evento para las FAQs (`{fecha_inicio}`/`{fecha_fin}`).
 *
 * Solo devuelve valor cuando hay un rango real de más de un día: falta alguna
 * fecha, no se puede interpretar, o inicio y fin caen el mismo día ⇒ `null`
 * (y las plantillas que lo usan se omiten).
 */
export function formatFaqDateRange(
  startAt: string | null,
  endAt: string | null,
): FaqDateRange | null {
  const start = extractDateParts(startAt)
  const end = extractDateParts(endAt)
  if (!start || !end) return null

  // `YYYY-MM-DD` ordena igual como cadena que como fecha.
  const startKey = `${start.year}-${start.month}-${start.day}`
  const endKey = `${end.year}-${end.month}-${end.day}`
  if (endKey <= startKey) return null

  const inicio = formatLongDate(start)
  const fin = formatLongDate(end)
  if (!inicio || !fin) return null

  return { inicio, fin }
}
